import AddOrganizationView from '@/modules/organisations/add-organisation'

const AddOrganizationPage = () => {
  return <AddOrganizationView />
}

export default AddOrganizationPage